export default function() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo-projection/src/noop.js
// module id = 739
// module chunks = 0